export default "__VITE_ASSET__DLG2N9WU__"